import React from 'react';
import { useTheme, useMediaQuery, Container } from '@mui/material';
import {
  FooterContainer,
  MarketPlaceHeading,
  FooterMainContent,
  FooterInfoContainer,
  FooterBottomContent,
  LegalTextContainer,
  LegalTextSpan,
  FooterMarketplaceImage,
  FooterLeftContent,
  FooterLegalLinks,
  FooterRightContent,
  FooterSectionGroup,
  ResponsiveFooterWrapper,
  Separator,
  SocialMediaContainer
} from './styles';
import Marketplace from './marketplace';
import Solutions from './solutions';
import Industries from './industries';
import Resources from './resources';
import Contact from './contact';
import Socials from './socials';
import MarketplaceLogo from '../../assets/MarketplaceLogo.svg?url';
import { useTranslatedObject } from '../../utils/translation';
import parse from 'html-react-parser';
import { FooterLegalLinksClick, sendGA4Data } from '../../analytics/events';
import { SdfButton } from '@waypoint/react-components';

export const SharedFooter = ({ navigate, onContactUsClick }) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  const year = new Date().getFullYear();
  const footer = useTranslatedObject('footer', { year });

  const handleCookiePreferencesClick = () => {
  window.OneTrust?.ToggleInfoDisplay();
  sendGA4Data(FooterLegalLinksClick, { eventLabel: 'To manage your preferences' });
  };

  const handleFooterLegalLinkClick = (label) => {
    sendGA4Data(FooterLegalLinksClick, { eventLabel: label });
  };

  return (
    <FooterContainer id="footer-container" role="contentinfo">
      <Container id="desktop-container" maxWidth="xxl">
        <FooterMainContent id="footer-main-content">
          <ResponsiveFooterWrapper
            id="responsive-footer-wrapper"
            isMobileOrTablet={isMobileOrTablet}
          >
            <FooterInfoContainer id="about-adp-container">
              <MarketPlaceHeading id="adp-marketplace-heading">
                {footer?.adp_marketplace}
                <Marketplace navigate={navigate} />
              </MarketPlaceHeading>
            </FooterInfoContainer>
            <FooterInfoContainer id="solutions-container">
              <MarketPlaceHeading id="solutions-heading">
                {footer.solutions}
                <Solutions isMobileOrTablet={isMobileOrTablet} navigate={navigate} />
              </MarketPlaceHeading>
            </FooterInfoContainer>
            {footer?.industries && (
              <FooterInfoContainer id="industries-container">
                <MarketPlaceHeading id="industries-heading">
                  {footer.industries}
                  <Industries isMobileOrTablet={isMobileOrTablet} navigate={navigate} />
                </MarketPlaceHeading>
              </FooterInfoContainer>
            )}
            <FooterInfoContainer id="resources-contact-container">
              <FooterSectionGroup id="resources-contact-group">
                {footer?.resources_and_insights && footer?.resource_links?.length > 0 && (
                  <div id="resources-container">
                    <MarketPlaceHeading id="resources-heading">
                      {footer.resources_and_insights}
                      <Resources />
                    </MarketPlaceHeading>
                  </div>
                )}
                <div id="contact-container">
                  <MarketPlaceHeading id="contact-heading">
                    {footer.contact_and_connect}
                    <Contact navigate={navigate} onContactUsClick={onContactUsClick} />
                  </MarketPlaceHeading>
                </div>
              </FooterSectionGroup>
            </FooterInfoContainer>
            <SocialMediaContainer
              id="socials-container"
              isMobileOrTablet={isMobileOrTablet}
            >
              <FooterInfoContainer id="socials-inner-container">
                <MarketPlaceHeading id="socials-heading">
                  <Socials navigate={navigate} />
                </MarketPlaceHeading>
              </FooterInfoContainer>
            </SocialMediaContainer>
          </ResponsiveFooterWrapper>
        </FooterMainContent>
        <FooterBottomContent id="footer-bottom-content">
          <FooterRightContent id="footer-right-content">
            <FooterMarketplaceImage src={MarketplaceLogo} alt="marketplace-logo" />
            <LegalTextContainer id="legal-text-container">
              <LegalTextSpan id="legal-text-span-1" component="span">
                 {parse(footer?.legal_disclaimer || '')}
              </LegalTextSpan>
            </LegalTextContainer>
          </FooterRightContent>
          <FooterLeftContent>
            <span>
              {footer?.legal_links?.map((link, index, arr) => (
                <React.Fragment key={index}>
                  <FooterLegalLinks
                    id={`footer-legal-link-${index}`}
                    href={link.url}
                    onClick={()=> handleFooterLegalLinkClick(link.label)}
                  >
                    {link.label}
                  </FooterLegalLinks>
                  {index < arr.length - 1 && <Separator />}
                </React.Fragment>
              ))}
            </span>
              <SdfButton id="ot-sdk-btn" className="mt-2 text-sm rounded cursor-pointer" onClick={handleCookiePreferencesClick}>
                  <span className="cookie-text">To manage your preferences, click here.</span>
              </SdfButton>
          </FooterLeftContent>
        </FooterBottomContent>
      </Container>
    </FooterContainer>
  );
};